import { Route } from "react-router-dom";
import Members from "./Members";
import List from "./List";
import MemberDetails from "./MemberDetails";
import AddMember from "./AddMember";
import UpdateMember from "./UpdateMember";
import Add from "./MemberCars/Add";
import Update from "./MemberCars/Update";

export default (
  <Route path="members" exact element={<Members />}>
    <Route index element={<List />} />
    <Route path="MemberDetails/:id" element={<MemberDetails />} />
    <Route path="add" element={<AddMember />} />
    <Route path="edit/:id" element={<UpdateMember />} />
    <Route path="addCar/:mid" element={<Add />} />
    <Route path=":mid/updateCar/:id" element={<Update />} />
  </Route>
);
